import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Consumivel } from '../../../../types/Consumivel.type';
import { Instancia } from '../../../../types/Instancia.type';

@Component({
  selector: 'app-baixaconsumiveis',
  templateUrl: './baixaconsumiveis.component.html',
  styleUrl: './baixaconsumiveis.component.css',
    providers: [DatePipe]
})
export class BaixaconsumiveisComponent implements OnInit {

  consumiveis!: Consumivel[];
  consumiveisSelecionados: Consumivel[] = []
  loading: boolean = false;
  rangeDates!: string;

  instancias: Instancia[] = [
      { id: 'VALE', nome: 'VALE' },
      { id: 'UCP', nome: 'UCP' },
      { id: 'UVP', nome: 'UVP' },
    ];
  instanciaSelecionada!: string

  constructor(private integradorService: IntegradorService, private toastService: ToastService, private datePipe: DatePipe){}

  ngOnInit(){
    this.getConsumiveis();
  }

  getConsumiveis(){

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    this.loading = true
    this.integradorService.getConsumiveis(this.instanciaSelecionada, dataInicial, dataFinal).subscribe({
      next: (data) => {
        this.consumiveis = data;
      },
      error: (error) => {
        this.toastService.erro(error.error.title, "Erro ao buscar: " + error.error.detail)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}

getDataPipeTransForm(data: string): string | null {
  return this.datePipe.transform( data,'yyyy-MM-dd');
}

exportar(){
  if (
    this.instanciaSelecionada == undefined
  ) {
    this.toastService.alerta('Instância', 'Selecione uma instância');

    return;
  }

  if (this.rangeDates == undefined) {
    this.toastService.alerta('Período', 'Selecione o período');

    return;
  }

  

  if(this.consumiveisSelecionados.length > 0){
    this.loading = true;
    
    let ids = this.consumiveisSelecionados.map(m => m.idConsum)

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem("cdUsuarioErp")
    }

  this.integradorService
    .exportarConsumiveis(
      corpo
    )
    .subscribe({next: (value) => {
      const url = window.URL.createObjectURL(value);
      const a = document.createElement('a')
      a.href = url
      a.download = 'data.xlsx'
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    error: (error) => {
      this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
    },
    complete: () => {
      this.loading = false;
    },
      
    });

    
  }else{
    this.toastService.info("Exportar", 'Necessário selecionar os registros que devem ser exportados');
  }
}
}
